import { deleteLicense } from 'commons/service/bank/license'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteLicense: WriteHook<number, void> = (opts) => useMutationManager(deleteLicense, opts)
